import moment from "moment/moment";

export function changeTenantProrata(values, tenant) {
  const hasChanged =
    values.fin !== tenant.fin || values.preavis !== tenant.preavis;
  const finIsPastMonth = moment().isAfter(tenant.fin, "month");
  const finIsCurrentMonthAfterPaymentDay =
    moment().isSame(tenant.fin, "month") &&
    moment().isAfter(moment().set("date", tenant.day_payment));
  return hasChanged && (finIsPastMonth || finIsCurrentMonthAfterPaymentDay);
}
